/**
 * WebSocket(PartyKit) ベースのチャンネルファクトリ（自前・GPL非依存）。
 *
 * PartyKit の「ルーム」へ接続し、サーバー（party/relay.ts）が受信を同室の
 * 他者へ再ブロードキャストする（送信者は除外＝BroadcastChannel と同じ意味論）。
 * これにより loopback と同一ロジックで遠隔対戦が成立する。
 *
 * host は `VITE_PARTYKIT_HOST`（例: pool-relay.<user>.partykit.dev / 127.0.0.1:1999）。
 * PartySocket は host が localhost/IP のとき ws://、それ以外は wss:// を自動選択する。
 */

import PartySocket from 'partysocket';
import type { ChannelFactory, MsgChannel } from './channel.js';

/** 指定ホストの PartyKit に接続する ChannelFactory を返す。 */
export const wsChannelFactory =
  (host: string): ChannelFactory =>
  <T>(room: string): MsgChannel<T> => {
    // PartyKit の room id は URL パスに載るため安全な文字へ正規化する。
    const safeRoom = room.replace(/[^a-zA-Z0-9_-]/g, '-');
    const socket = new PartySocket({ host, room: safeRoom });
    let handler: ((msg: T) => void) | null = null;
    socket.addEventListener('message', (ev: MessageEvent): void => {
      if (!handler) return;
      try {
        handler(JSON.parse(ev.data as string) as T);
      } catch (err) {
        console.error('channel受信パース失敗:', err);
      }
    });
    return {
      post: (msg: T): void => {
        try {
          socket.send(JSON.stringify(msg));
        } catch (err) {
          console.error('channel送信失敗:', err);
        }
      },
      onMessage: (cb: (msg: T) => void): void => {
        handler = cb;
      },
      close: (): void => {
        handler = null;
        socket.close();
      },
    };
  };
